import React, { useState } from 'react';

import SearchFilterButton from '../../../common/SearchFilterButton';
import SearchFilterDrawer, {
  BaseSearchFilterProps
} from '../../../common/SearchFilterDrawer';
import { InlineFormControl } from '../../../common/inline/InlineFormControl';
import SupplierStatusFilter from './SupplierStatusFilter';

export interface SupplierFilterOptions {
  status?: string[];
}

function createInitialOptions(): SupplierFilterOptions {
  return {};
}

export type SupplierListFilterProps = BaseSearchFilterProps<SupplierFilterOptions>;

const SupplierListFilter: React.FC<SupplierListFilterProps> = (
  props: SupplierListFilterProps
) => {
  const { onFilter } = props;
  const [open, setOpen] = useState<boolean>(false);
  const [options, setOptions] = useState<SupplierFilterOptions>(
    createInitialOptions()
  );

  const updateOptions = (updatedData: Partial<SupplierFilterOptions>) => {
    setOptions({ ...options, ...updatedData });
  };

  return (
    <>
      <SearchFilterButton onClick={() => setOpen(true)} />
      <SearchFilterDrawer
        open={open}
        title='Filter Suppliers'
        onClose={() => setOpen(false)}
        onClear={() => setOptions(createInitialOptions())}
        onFilter={() => {
          setOpen(false);
          onFilter?.(options);
        }}
      >
        <InlineFormControl label='Status'>
          <SupplierStatusFilter
            value={options.status}
            onChange={status => updateOptions({ status })}
          />
        </InlineFormControl>
      </SearchFilterDrawer>
    </>
  );
};

export default SupplierListFilter;
